<template>
  <div>
    <label :for="id">{{ label }}</label>
    <input
      class="advanced-checkbox"
      :id="id"
      type="checkbox"
      v-model="value"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { advancedOptionToRenderConfig } from '@/utils/advancedOptions'

export default {
  name: 'CheckboxInput',

  props: {
    id: {
      type: String,
      required: true,
    },
    advanced_option: {
      required: true,
      type: String,
    },
    question_index: {
      required: true,
      type: Number,
    },
    questions_groups_index: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      optionConfig: null,
      label: '',
      required: false,
    }
  },

  computed: {
    ...mapGetters(['questionGroups']),

    value: {
      get() {
        return (
          this.questionGroups[this.questions_groups_index].questions[this.question_index]
            .advancedOptions[this.advanced_option] || ''
        )
      },

      set(value) {
        this.$store.dispatch('changeAdvanced', {
          questionGroupIndex: this.questions_groups_index,
          questionIndex: this.question_index,
          advancedKey: this.advanced_option,
          value,
        })
      },
    },

    disabled() {
      const currentOptions = this.questionGroups[this.questions_groups_index].questions[
        this.question_index
      ].advancedOptions

      const isDisabled = this?.optionConfig.disableChecker?.(currentOptions)

      return isDisabled
    },
  },

  watch: {
    language() {
      this.label = this.optionConfig.displayText[this.language]
    },
  },

  created() {
    this.optionConfig = advancedOptionToRenderConfig[this.advanced_option]
    this.label = this.optionConfig.displayText[this.language]
    this.required = this.optionConfig.required
  },
}
</script>

<style scoped lang="scss">
div {
  display: flex;
  align-items: center;
}

label {
  width: fit-content;
  white-space: nowrap;
  user-select: none;
  color: $gray-10;
  @include tipography(16);
  .light & {
    color: $main;
  }
}
input {
  outline: none;
  padding: 5px;
  width: 80px;
  border-radius: 4px;
  font-size: 15px;
  color: $gray-10;
  border: 1px solid $gray-6;
  &.text {
    width: 100%;
  }
  &:focus {
    border-color: $gray-7;
  }
}
</style>
